import Vue from "vue";
import VueI18n from "vue-i18n";
import Const from "@/utils/consts";
import zh_hans from "@/locales/zh-hans";
import zh_hant from "@/locales/zh-hant";
import en_Us from "@/locales/en-us";
import ja_Jp from "@/locales/ja-jp";
import ko_Kr from "@/locales/ko-kr";
import en_Sg from "@/locales/en-sg";
import de_De from "@/locales/de-de";
import fr_FR from "@/locales/fr-fr";
import ar_AE from "@/locales/ar-ae";

// 注册 VueI18n
Vue.use(VueI18n);

// 语言库
const messages = {
  "zh-hans": zh_hans,
  "zh-hant": zh_hant,
  "en-us": en_Us,
  "ja-jp": ja_Jp,
  "ko-kr": ko_Kr,
  "en-sg": en_Sg,
  "de-de": de_De,
  "fr-fr": fr_FR,
  "ar-ae": ar_AE,
};

// 默认语言
const defLang = { text: "English", lang: "en-us" };

// 从本地缓存获取语言
let lang = JSON.parse(localStorage.getItem(Const.KEY_LANG));
if (!lang) {
  lang = defLang;
}
console.log("Cache Lang", lang);

// 创建 i18n 实例（Vue 2 方式）
const i18n = new VueI18n({
  fallbackLocale: "en-us",
  locale: lang.lang,
  messages,
});

// 设置语言
export const setLangauge = (lang) => {
  if (lang === undefined) {
    // 检查浏览器是否缓存了语言
    lang = localStorage.getItem(Const.KEY_LANG);

    // 如果未缓存，或者缓存的语种不在 messages 中
    if (!lang || messages[lang.lang] === undefined) {
      lang = defLang;
    }
    // 初始化
    localStorage.setItem(Const.KEY_LANG, JSON.stringify(lang));
  } else {
    localStorage.setItem(Const.KEY_LANG, JSON.stringify(lang));
  }

  // 移除 body 上所有语言 class
  Object.keys(messages).forEach((langKey) => {
    document.body.classList.remove(`lang-${langKey}`);
  });
  // 给 body 添加当前语言 class
  document.body.classList.add(`lang-${lang.lang}`);
  // 设置 HTML lang 属性
  document.body.setAttribute("lang", lang.lang);

  // Vue 2 方式：直接修改 locale
  i18n.locale = lang.lang;
};

// 初始化
const current = localStorage.getItem(Const.KEY_LANG);
console.log("Current", current);
setLangauge(current == null ? undefined : JSON.parse(current));

export default i18n;
